import { Input } from "@/components/ui/input";

interface OtherTextInputProps {
  questionId: string;
  value: string;
  onChange: (questionId: string, value: string) => void;
  placeholder?: string;
  maxLength?: number;
}

/**
 * Inline free-text input shown when "Other" is selected on a
 * single_select or multi_select question.
 *
 * Stores the text under the key `{questionId}__other_text` in the
 * answers object so the primary answer value remains a plain string
 * (or string[]) and scoring is unaffected.
 */
export function OtherTextInput({
  questionId,
  value,
  onChange,
  placeholder = "Please describe...",
  maxLength = 500,
}: OtherTextInputProps) {
  return (
    <div className="ml-8 mt-2 max-w-md">
      <Input
        value={value}
        onChange={(e) => onChange(`${questionId}__other_text`, e.target.value.slice(0, maxLength))}
        placeholder={placeholder}
        maxLength={maxLength}
        className="text-sm"
        autoFocus
      />
      <p className="text-xs text-muted-foreground mt-1 text-right">
        {value.length}/{maxLength}
      </p>
    </div>
  );
}

/** Helper: checks whether a given option value represents "other". */
export function isOtherValue(value: string): boolean {
  return value.toLowerCase() === "other";
}

/** Key used to store "other" free-text alongside the main answer. */
export function otherTextKey(questionId: string): string {
  return `${questionId}__other_text`;
}
